import * as React from 'react'

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

interface UserAvatarProps {
  /** User's initials to show when no image */
  initials: string
  /** URL of the avatar image */
  imageUrl?: string | null
  /** Background color for initials (hex) */
  color?: string
  /** Size variant */
  size?: AvatarSize
  /** Additional CSS classes */
  className?: string
  /** Click handler */
  onClick?: (event: React.MouseEvent) => void
}

const sizeClasses: Record<AvatarSize, { container: string; text: string }> = {
  xs: { container: 'h-6 w-6', text: 'text-xs' },
  sm: { container: 'h-8 w-8', text: 'text-sm' },
  md: { container: 'h-10 w-10', text: 'text-sm' },
  lg: { container: 'h-12 w-12', text: 'text-base' },
  xl: { container: 'h-16 w-16', text: 'text-xl' },
  '2xl': { container: 'h-24 w-24', text: 'text-2xl' },
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  initials,
  imageUrl,
  color = '#6366f1',
  size = 'md',
  className = '',
  onClick,
}) => {
  const { container, text } = sizeClasses[size]
  const baseClasses = `${container} rounded-lg flex items-center justify-center font-bold ${className}`
  
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={initials}
        onClick={onClick}
        className={`${baseClasses} object-cover ${onClick ? 'cursor-pointer' : ''}`}
      />
    )
  }

  return (
    <div
      onClick={onClick}
      className={`${baseClasses} text-white ${text} ${onClick ? 'cursor-pointer' : ''}`}
      style={{ backgroundColor: color }}
    >
      {initials.toUpperCase()}
    </div>
  )
}

export default UserAvatar
